<template>
  <HXContentCard title="Nuevo Departamento" :toBack="{ name: 'Departamentos' }">
    <form @submit.prevent="saveData">
      <div class="d-flex justify-content-end pt-4 pr-3">
        <vs-button id="startButton" v-b-tooltip.hover title="Iniciar tutorial" circle icon danger relief
          @click.prevent="startTour">
          <i class="far fa-circle-play mr-1"></i>
          Tutorial Rápido
        </vs-button>
      </div>
      <TourGuideLineal ref="tourGuide" />
      <div class="row p-4">
        <div class="col-md-6" id="NombreDepartamento">
          <div>
            <label for=" " class="form-label">Nombre Departamento</label>
            <input v-model="item.Descripcion" required placeholder="Escriba el Nombre del departamento..." type="text"
              class="form-control" id=" " />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3" id="SeleccionarSucursal">
            <label for=" " class="form-label">Sucursal</label>
            <b-form-select v-model="item.SucursalId" required text-field="descripcion" value-field="id"
              :options="ListSucursales">
              <template #first>
                <b-form-select-option v-if="selected != null" selected :value="none" disabled>-- seleccionar Sucursal
                  --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-4">
            <label for=" " class="form-label">Empresa</label>
            <!-- <b-form-select
                    :disabled="usuario.rol.nivel != 4 ? true : false"
                    required
                    v-model="item.EmpresaId"
                    value-field="id"
                    text-field="nombre"
                    :options="ListEmpresas"
                  ></b-form-select> -->
            <b-form-select @change.native="getSucursalEmpresa($event.target.value)"
              :disabled="usuario.rol.nivel != 4 ? true : false" required v-model="item.EmpresaId" value-field="id"
              text-field="nombre" :options="ListEmpresas"></b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-md-5 px-3 pb-4 d-flex justify-content-end">
        <div class="d-flex justify-content-end">
          <vs-button primary icon animation-type="vertical" type="submit" class="mx-1" id="GuardarDepartamento">
            <i class="fas fa-save pr-1"></i>
            Guardar Departamento
            <template #animate>
              <i class="fas fa-save"></i>
            </template>
          </vs-button>
        </div>
      </div>
    </form>
  </HXContentCard>
</template>
<script>
import { core } from "../../../config/pluginInit";
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";

export default {
  name: "DataTable",
  components: {
    TourGuideLineal
  },
  data() {
    return {
      usuario: { rol: { nivel: 0 } },
      id: "",
      selected: null,
      item: {
        EmpresaId: "",
        SucursalId: "",
        Descripcion: "",
        Estado: 1,
      },
      ListEmpresas: [],
      ListSucursales: [],
      tourSteps: [
        {
          title: "Nombre Departamento",
          description:
            "En este apartado podrás definir el nombre de tu departamento.",
          elementId: "NombreDepartamento",
        },
        {
          title: "Seleccionar Sucursal",
          description:
            "En este apartado deberás seleccionar una Sucursal para asociar tu departamento.",
          elementId: "SeleccionarSucursal",
        },
        {
          title: "Guardar Departamento",
          description:
            "Por último, una vez diligenciada toda la información, deberás darle click en el botón de Guardar para finalizar.",
          elementId: "GuardarDepartamento",
        },
      ]
    };
  },
  async mounted() {
    this.$isLoading(true);
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.item.EmpresaId = this.usuario.empresa.id;

    this.id = this.$route.params.id;
    //   await this.getData();
    await this.getEmpresas();
    await this.getSucursalEmpresa(this.usuario.empresa.id);
    if (this.$route.query.habilitarTour) {
      this.startTour();
    }
    core.index();
    window.$("#datatable_empresa").DataTable();
    this.$isLoading(false);
  },
  methods: {
    async getSucursalEmpresa(id) {
      console.log(id);
      try {
        console.log("get empresas...");
        let res = await this.$store.dispatch("hl_get", {
          path: "Sucursal/ListSucursalEmpresa/" + id,
        });
        console.log("post sucursal... ", res);
        if (res.length > 0) {
          this.ListSucursales = res;
        } else {
          this.ListSucursales = [];
        }
      } catch (error) {
        this.ListSucursales = [];
        console.log("err", error);
      }
    },
    async getEmpresas() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Empresa/ListEmpresa/",
        });
        this.ListEmpresas = res;

        console.log("list", this.ListEmpresas);
      } catch (error) {
        this.ListEmpresas = {};
        console.log("err", error);
      }
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Departamento/GetDepartamento/" + this.id,
        });
        this.item = res;

        console.log(" ", this.item);
      } catch (error) {
        this.item = {};
        console.log("err", error);
      }
    },
    async saveData() {
      console.log("saving", this.item);
      try {
        //this.item.EmpresaId = this.item.empresa.id;
        // this.item.municipio.departamentoPaisId = this.item.municipio.departamentoPais.id
        //this.item.Descripcion = this.item.descripcion;
        //this.item.SucursalId = this.item.sucursal.id;

        let res = await this.$store.dispatch("hl_post", {
          path: "Departamento/CreateDepartamento/",
          data: this.item,
        });
        console.log("post empresas...", res);
        if (res) this.$router.push("/helex/Departamentos");
        else alert("Verificar");
      } catch (error) {
        this.item = {};
        console.log("err", error);
      }
    },
    startTour() {
      this.$refs.tourGuide.startTour(
        this.tourSteps
      );
    },
  },
};
</script>
